<div class="filter-section">
  <div class="filter-section-header">
    <ion-label>{{ title }}</ion-label>
  </div>
  <div class="filter-section-content">
    <ng-content></ng-content>
  </div>
</div>
